
import React from 'react';
import PropTypes from 'prop-types';
import ButtonStyled from './button.styled';
import { Loader } from 'zengenti-forms-package/components/loader';

export const Button = ({
  className,
  type = 'button',
  text,
  action,
  loading,
  useDefaultTheme,
}) => {
  return (
    <ButtonStyled
      className={className}
      type={type}
      onClick={() => action()}
      disabled={loading}
      useDefaultTheme={useDefaultTheme}
    >
      {text}
      {loading && <Loader height={18} width={18} />}
    </ButtonStyled>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  text: PropTypes.string,
  action: PropTypes.func,
  loading: PropTypes.bool,
  useDefaultTheme: PropTypes.bool,
};

export default Button;
